module.exports = __webpack_public_path__ + "images/kihnu/back.jpg";